import Base from "../../base/Base";
import Article from "../../article/Article";
import Vue from "vue";
let Type = {
	ARTICLE: "ARTICLE",
	URL: "URL"
};

let TypeMap = {

	ARTICLE: {
		name: "链接文章",
		value: "ARTICLE",
		style: "success"
	},
	URL: {
		name: "自定义链接",
		value: "URL",
		style: "info"
	}
};

let TypeList = [];
for (let key in TypeMap) {
	TypeList.push(TypeMap[key]);
}


export default function Item(name) {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.name = name;

	this.type = Type.ARTICLE;
	this.article = new Article();
	this.articleId = null;
	this.url = null;
}


//extend Base's methods.
Item.prototype = new Base();
Item.prototype.constructor = Item;

Item.prototype.Type = Type;
Item.prototype.TypeMap = TypeMap;
Item.prototype.TypeList = TypeList;


//We use this method to get the full js Object.
Item.prototype.render = function (obj) {

	Base.prototype.render.call(this, obj);

	//这里我们并不关心文章是什么，只关心id.
	if (obj && obj.articleId) {
		this.article.id = obj.articleId;
	}

}


Item.prototype.getForm = function () {


	return {
		name: this.name,
		type: this.type,
		articleId: this.article.id,
		url: this.url
	};
}


Item.prototype.validate = function () {


	if (!this.name) {
		this.errorMessage = "条目的名称必填！";
		return false;
	}

	if (this.type === Type.ARTICLE) {

		if (!this.article.id) {
			this.errorMessage = "必须关联一篇文章！";
			return false;
		}

	} else if (this.type === Type.URL) {
		if (!this.url) {
			this.errorMessage = "链接必填！";
			return false;
		}
	}


	return true;

}
Item.prototype.finish = function () {

	if (this.validate()) {
		this.errorMessage = null;
		this.editMode = false;
	}

}

Item.prototype.toggleEdit = function () {

	if (this.editMode) {
		this.finish();
	} else {
		this.editMode = true;
	}

}
Item.prototype.click = function (topic) {

	if (this.type === Type.ARTICLE) {
		Vue.router.push("/" + topic.location + "/article/detail/" + this.articleId);
	} else if (this.type === Type.URL) {
		window.open(this.url);
	} else {
		console.error("未知的条目类型");
	}

}



// WEBPACK FOOTER //
// ./src/common/model/lover/theme/Item.js